import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { FcpInputModule } from '../fcp-input';
import { FcpBadgeModule } from '../fcp-badge';
import { FcpIconModule } from '../fcp-icon';
import { FcpDropdownTreeComponent } from './fcp-dropdown-tree.component';
import { FcpTooltipModule } from '../fcp-tooltip';
import { FcpToggleSwitchModule } from '../fcp-toggle-switch';

@NgModule({
    declarations: [FcpDropdownTreeComponent],
    imports: [
        CommonModule,
        FcpIconModule,
        FcpBadgeModule,
        FcpInputModule,
        FcpTooltipModule,
        OverlayModule,
        FcpToggleSwitchModule
    ],
    exports: [FcpDropdownTreeComponent]
})
export class FcpDropdownTreeModule {}
